import React from 'react'
import { numberFormat } from '../../../helpers/numberFormat'
import { numberToDateString } from '../../../helpers/numberToDateString'
import Table from 'react-bootstrap/Table';


const RiwayatTransaksiDetailProgramComp = (props) => {
    return (
        <div className='table-responsive'>
            <table className='table mb-3'>
                <thead>
                    <tr>
                        <th className='white-bg'>Nama Program</th>
                        <th className='white-bg'>Jadwal Program</th>
                        <th className='white-bg'>Harga</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.transactionItems.map((row, index) => (
                            <tr key={index}>
                                <td>{row.Schedule.Program.name}</td>
                                <td>{numberToDateString(row.Schedule.startDate)} s/d {numberToDateString(row.Schedule.endDate)}</td>
                                <td style={{ color: '#0C86D9', fontSize: '16px' }}>{numberFormat(row.price)}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    )
}

export default RiwayatTransaksiDetailProgramComp
